import { ISponsor } from "../../../../models/Sponsor"
import React from "react";

export const SponsorCard: React.FC<{ sponsor: ISponsor }> = ({ sponsor }) => {
    return (
        <a className="sponsor-card" href={sponsor.link || undefined} target="_blank" rel="noopener noreferrer">
            <div className="sponsor-card__logo">
                <img src={sponsor.logoUrl} alt={sponsor.description} loading="lazy" />
            </div>
            <span className="sponsor-card__name">
                {sponsor.description}
            </span>
        </a>
    )
}
